// Generated by scripts/build-ui-icons.mjs.
export { ShieldCheck as default } from "../ui/glyphs-6";
